<template>
  <div>
    <div class="px-4 card-title align-center justify-between flex">
      <span class="h9-text text-uppercase">{{ $t('Catalog.DeliveryAddress') }}</span>
    </div>
    <div
      class="font-size-14 pl-4 text-left">
      <div v-if="chosed_address.name">
        {{ chosed_address.name }}
      </div>
      <div v-if="chosed_address.title">
        {{ chosed_address.title }}
      </div>
      <div v-if="chosed_address.organizationAddress">
        {{ chosed_address.organizationAddress.address }}
      </div>
      <div v-if="chosed_address.city ">
        {{ chosed_address.postalCode }},
        {{ $t('Common.City') }} {{ chosed_address.city }},
        {{ chosed_address.street }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'editPurchAddress',
  data() {
    return {
      value: '',
      addresses: [],
      new_address: {},
      dialog: false
    }
  },
  props: {
    address: Object
  },
  computed: {
    chosed_address: {
      get() {
        if (!this.addresses?.length && this.address ) {
          return this.address
        }
        if (!this.address) { return null }
        return this.addresses.find( el => el.id == this.address.id || el.id == this.address) || this.address
      },
      set(value) {
        if (value === this.address) {
          return
        }
        this.$emit('update:address', value)
      }
    },
  },
}
</script>
